<form  [formGroup]="form">
    <div class="card-box-medium margin-right-small">
        <h3>Datos factura</h3>
        <mat-divider></mat-divider>
        <div class="aling-top full-width margin-top-medium">
            <mat-form-field class="medium-width margin-right-small">
                <mat-select (selectionChange)="changeInvoicePoint()" placeholder="Punto de venta" formControlName="InvoicePoint" required>
                    <mat-option *ngFor="let invoicePoint of invoicePoints" [value]="invoicePoint">
                        {{ invoicePoint.Name }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="!f.InvoicePoint.valid">
                    Ingrese el punto de venta
                </mat-error>
            </mat-form-field>

            <mat-form-field class="medium-width">
                <input type="text" matInput placeholder="Período" formControlName="BillingInvoicePeriod" [matAutocomplete]="autBillinInvoicePeriod">
                <mat-autocomplete #autBillinInvoicePeriod="matAutocomplete" [displayWith]="filterCompleteBillinInvoicePeriod.displayFn">
                    <mat-option *ngFor="let billinInvoicePeriod of filteredBillinInvoicePeriodOptions | async" [value]="billinInvoicePeriod">
                        {{ billinInvoicePeriod.Name }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <div class="card-inline full-width">
                <client-autocomplete (clientChange)="setValuesByClientChange($event)" formControlName="ClientSearch"></client-autocomplete>
            </div>

            <mat-form-field *ngIf="visibleDatesFromTo" class="medium-width margin-right-small">
                <input matInput autocomplete="off" formControlName="InvoiceFrom" [matDatepicker]="invoiceFrom" placeholder="Fecha inicio">
                <mat-datepicker-toggle matSuffix [for]="invoiceFrom"></mat-datepicker-toggle>
                <mat-datepicker #invoiceFrom></mat-datepicker>
            </mat-form-field>

            <mat-form-field *ngIf="visibleDatesFromTo" class="medium-width margin-right-small">
                <input matInput autocomplete="off" formControlName="InvoiceTo" [matDatepicker]="invoiceTo" placeholder="Fecha fín">
                <mat-datepicker-toggle matSuffix [for]="invoiceTo"></mat-datepicker-toggle>
                <mat-datepicker #invoiceTo></mat-datepicker>
            </mat-form-field>

            <div *ngIf="visibleIsRejectedOptions" class="card-inline full-width">
                <mat-radio-group formControlName="IsRejected">
                    <mat-radio-button class="margin-right-small" value="true">Comp. asoc. rechazado por el comprador</mat-radio-button>
                    <mat-radio-button value="false">Comp. asoc. aceptado por el comprador</mat-radio-button>
                </mat-radio-group>
            </div>

            <div *ngIf="visibleCirculacionAbierta" class="card-inline full-width">
                <mat-radio-group formControlName="IsCirculacionAbierta">
                    <mat-radio-button checked="true" class="margin-right-small" value="true">Transferencia al sistema de circ. abierta</mat-radio-button>
                    <mat-radio-button value="false">Agente de dep. colectivo</mat-radio-button>
                </mat-radio-group>
            </div>

            <div *ngIf="visibleBillingInvoiceAssociate" class="card-inline full-width">
                <app-billing-invoice-associate-auto-complete (invoiceAssociateChange)="onInvoiceAssociateChange($event)"></app-billing-invoice-associate-auto-complete>
            </div>

            <mat-form-field class="medium-width margin-right-small">
                <input matInput autocomplete="off" formControlName="InvoiceDate" [matDatepicker]="invoiceDate" placeholder="Fecha factura">
                <mat-datepicker-toggle matSuffix [for]="invoiceDate"></mat-datepicker-toggle>
                <mat-datepicker #invoiceDate></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="medium-width margin-right-small">
                <input matInput autocomplete="off" formControlName="InvoiceExpiredDate" [matDatepicker]="invoiceExpireDate" placeholder="Fecha vencimiento">
                <mat-datepicker-toggle matSuffix [for]="invoiceExpireDate"></mat-datepicker-toggle>
                <mat-datepicker #invoiceExpireDate></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="card-inline  margin-right-small">
                <mat-label>Importe neto</mat-label>
                <input type="number" matInput formControlName="Amount">
                <mat-error *ngIf="!f.Amount.valid">
                    Ingrese importe neto
                </mat-error>
            </mat-form-field>

            <mat-form-field class="margin-right-small">
                <mat-select formControlName="TaxpayerType" required>
                    <mat-option *ngFor="let taxpayerType of taxpayerTypes" [value]="taxpayerType">
                        {{ taxpayerType.Name }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="!f.TaxpayerType.valid">
                    Ingrese el tipo contribuyente impositivo
                </mat-error>
            </mat-form-field>

            <mat-form-field class="margin-right-small">
                <mat-select placeholder="Tipo factura" formControlName="InvoiceLabelType" required>
                    <mat-option *ngFor="let invoiceLabelType of invoiceLabelTypes" [value]="invoiceLabelType">
                        {{ invoiceLabelType.Name }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="!f.InvoiceLabelType.valid">
                    Ingrese el tipo de factura
                </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width margin-right-small">
                <mat-label>Descripción</mat-label>
                <input matInput autocomplete="off" formControlName="Description">
                <mat-error *ngIf="!f.Description.valid">
                    Debe ingresar una descripción
                </mat-error>
            </mat-form-field>

        </div>
    </div>
    <div class="card-box-medium margin-right-small">
        <h3>Impuestos</h3>
        <mat-divider></mat-divider>
        <table class="search-table" mat-table *ngIf="invoiceTaxes.controls.length > 0" [dataSource]="invoiceTaxesDataSource" formArrayName="InvoiceTaxes">
            <tr mat-header-row class="search-table-header" *matHeaderRowDef="displayInvoiceTaxesColumns"></tr>
            <tr mat-row class="search-table-cell" *matRowDef="let row; let i = index; columns: displayInvoiceTaxesColumns;"></tr>

            <ng-container matColumnDef="TaxTypeName">
                <th mat-header-cell class="table-header" *matHeaderCellDef> Impuesto </th>
                <td mat-cell class="table-cell" *matCellDef="let row; let index = index" [formGroupName]="index">
                    {{ displayTaxTypeName(index) }}
                </td>
            </ng-container>

            <ng-container matColumnDef="Aliquot">
                <th mat-header-cell class="table-header" *matHeaderCellDef> Alícuota </th>
                <td mat-cell class="table-cell" *matCellDef="let row; let index = index" [formGroupName]="index">
                    <mat-select formControlName="Aliquot">
                        <mat-option *ngFor="let aliquot of displayAmountAliquots(index)" [value]="aliquot">
                            {{ aliquot }}
                        </mat-option>
                    </mat-select>
                </td>
            </ng-container>

            <ng-container matColumnDef="Amount">
                <th mat-header-cell class="table-header" *matHeaderCellDef>Importe </th>
                <td mat-cell class="table-cell" *matCellDef="let row; let index = index" [formGroupName]="index">
                    {{ displayAmount(index) }}
                </td>
            </ng-container>
        </table>
        <div class="margin-top-medium margin-left-medium">
            <mat-label><b> {{ totalAmount }} </b></mat-label>
        </div>
    </div>
</form>
